import script from "./Register.vue?vue&type=script&lang=ts&setup=true"
export * from "./Register.vue?vue&type=script&lang=ts&setup=true"

import "./Register.vue?vue&type=style&index=0&id=11b3261c&lang=scss"

const __exports__ = script;

export default __exports__